export function ImageLibraryViewModel(data) {
	var self = this;
	self.type= "ImageLibraryViewModel"

	self.rootvm = data.rootvm;

	self.initialized = ko.observable(false);
	self.initialize = function() {
		if (!self.initialized()){
			// get all images
			self.is_busy(true);
			self.get_tags();
			self.get_images();
			self.initialized(true);
		}
	}

	self.afterHide = function() {
		if (self.initialized()){
			self.initialized(false);
		}
	}

	self.is_busy = ko.observable(false);

	self.url_prefix = self.rootvm.image_path_prefix;
	self.path_title = "/uploads/title/";
	self.path_content = "/uploads/content/";
	self.path_preview = "/uploads/preview/";
	self.file_extension = ko.observable('.webp');

	self.images = ko.observableArray([]);

	self.selected_image = ko.observable(undefined);
	self.set_selected_image = function(image){
		self.selected_image(image);
	}

	self.example_image = ko.pureComputed(function () {
		return '<Image params"img: \'' + self.selected_image().filename + '\', alt: \'' + self.selected_image().description + '\'"></Image>';
	});
	self.example_header_image = ko.pureComputed(function () {
		return '{% set img_src=\'' + self.selected_image().filename + '\' %}\n' +
		'{% set img_position=\'CHOOSE top, center, bottom\' %}\n{% set headline=\'' + self.selected_image().description + '\' %}\n' +
		'{% set subline= \'ADD TEXT HERE\' %}\n' +
		'{% include \'static/js-modules/jinja-templates/header-image.html\' with context %}';
	});
	self.example_tile = ko.pureComputed(function () {
		return 'image: \'' + self.selected_image().filename + '\',\n' +
			'title: \'' + self.selected_image().description + '\',';
	});
	self.example_image_tile = ko.pureComputed(function () {
		return 'image: \'' + self.selected_image().filename + '\',\n' +
			'alt: \'' + self.selected_image().description + '\',';
	});
	self.example_meta_img = ko.pureComputed(function () {
		return '\"meta_image\" \: \"' + self.selected_image().filename + '\"';
	});

	self.get_images = function () {
		self.is_busy(true);
		return $.ajax({
			url: '/api/tools/image-library',
			type: 'GET',
			cache: true,
			contentType: "text/json; charset=utf-8",
			success: function (data) {
				self.images(data.images);
			},
			complete: function () {
				self.is_busy(false);
			}
		});
	}

	self.get_tags = function () {
		self.is_busy(true);
		return $.ajax({
			url: '/api/tools/image-tags',
			type: 'GET',
			cache: true,
			contentType: "text/json; charset=utf-8",
			success: function (data) {
				self.available_tags(data.tags);
			},
			complete: function () {
				self.is_busy(false);
			}
		});
	}

	// filter images
	self.available_tags = ko.observableArray([]);
	self.selected_tags = ko.observableArray([]);
    self.filter_image_search = ko.observable();
	self.filter_tags = ko.pureComputed(() => self.selected_tags().length ? self.selected_tags() : self.available_tags());


	self.filtered_images = ko.pureComputed(() =>{
		var filter1 = self.images().filter(image =>
			image.tags.some(tag => self.filter_tags().includes(tag))
		)
        if(self.filter_image_search()){
            return ko.utils.arrayFilter(filter1, (image) =>{
                if(image.filename.indexOf(self.filter_image_search()) >= 0 ||
                   image.description.indexOf(self.filter_image_search()) >= 0 ){
                    return image;
                }
            });
        }
        else{
            return filter1;
        }
	});
	self.filtered_images.subscribe(() => {
		self.page_current(1);
	});

	self.filtered_images_and = ko.pureComputed(() =>
		self.images().filter(image =>
			self.filter_tags().every(tag => image.tags.includes(tag))
		)
	);

	// pagination
	self.images_per_page = ko.observable(30);
	self.first_image = ko.pureComputed(() => (self.page_current()-1) * self.images_per_page());
	self.last_image = ko.pureComputed(() => self.page_current() * self.images_per_page());
	self.page_current = ko.observable(1);
	self.pages_total = ko.pureComputed(() => Math.ceil(self.filtered_images().length / self.images_per_page()));
	self.paged_images = ko.pureComputed(() => self.filtered_images().slice(self.first_image(), self.last_image()));

	self.show_page_index = (index) => {
		// show first page
		if (index === 1) return true;
		// show last page
		if (index === self.pages_total()) return true;
		// show every 5th page
		if (index % 5 === 0) return true;
		// show prev/next 3 pages
		if (Math.abs(self.page_current() - index) <= 3) return true;
		return false
	};
}
